import styles from './HangUpButton.module.scss'
import {CallIcon} from '../../../assets'

const HangUpButton = ({...props}) => {
  return <button className={styles.button} {...props}>
    <CallIcon/>
  </button>
}

export default HangUpButton